import React from 'react';
import { useTranslation } from 'react-i18next';
import useIconFromRowName from '../../../hooks/useIconFromRowName';

import { Row, RowLeft, RowRight, Icon, IconImg, Feature, CPOCheck } from '../VehicleHistory.styles';

interface RowProps {
  row: string;
}

const RowItem: React.FC<RowProps> = ({ row }) => {
  const { t } = useTranslation();
  const icon = useIconFromRowName(row);
  return (
    <Row>
      <RowLeft>
        <Icon>
          <IconImg src={icon} alt={`${row} icon`} />
        </Icon>
        <Feature>{t(`vehicleHistory.${row}`)}</Feature>
      </RowLeft>
      <RowRight>
        <Feature>{t('vehicleHistory.passed')}</Feature> <CPOCheck />
      </RowRight>
    </Row>
  );
};

export default RowItem;
